export interface NamedPerson {
  id: number
  first_name: string
  last_name: string
}

function norm(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
}

/** Other people who share the first name or the first surname ("Nome parecido"). */
export function similarNames<T extends NamedPerson>(person: T, all: T[]): T[] {
  const first = norm(person.first_name)
  const surname = norm(person.last_name).split(/\s+/)[0] ?? ''
  return all.filter(
    (other) =>
      other.id !== person.id &&
      ((first !== '' && norm(other.first_name) === first) ||
        (surname !== '' && (norm(other.last_name).split(/\s+/)[0] ?? '') === surname)),
  )
}
